var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("title",{"key":1},"envelope"),React.createElement("rect",{"className":"a","x":"0.75","y":"4.5","width":"22.5","height":"15","rx":"1.5","ry":"1.5","key":2}),React.createElement("line",{"className":"a","x1":"15.687","y1":"9.975","x2":"19.5","y2":"13.5","key":3}),React.createElement("line",{"className":"a","x1":"8.313","y1":"9.975","x2":"4.5","y2":"13.5","key":4}),React.createElement("path",{"className":"a","d":"M22.88,5.014l-9.513,6.56a2.406,2.406,0,0,1-2.734,0L1.12,5.014","key":5})]);
}

Envelope.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Envelope;

Envelope.default = Envelope;
